import { LangUri, Environment } from '@catawiki/runtime-toolkit';
export const langUri = LangUri.LangUri.of(Environment.isClientSide() ? window.location.href : '');
export const HELP_COOKIES_PATH = '/help/cookies';
export const API_COOKIES_ENDPOINT = '/accounts/api/v2/users/cookies';
export const COOKIES_ROUTE = langUri.generatePath(HELP_COOKIES_PATH);
//# sourceMappingURL=routes.js.map